import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class LocationService {
    
    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/location/get'), callback, queryParams);
    getPointLocation = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/location/point-location'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/location/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/location/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/location/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/location/delete/${id}`), callback);
    
}